module.exports = __webpack_public_path__ + "static/img/qy1_2_4.0384261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qy1_2_4.jpg
// module id = XG21
// module chunks = 0